import { googleAnalyticsLib } from 'freedom-shared';

export const aviaTourPromoOfferShown = () =>
  googleAnalyticsLib.sendEvent('trfree_offer_shown', { source: 'avia' });

export const aviaTourPromoOfferClicked = () =>
  googleAnalyticsLib.sendEvent('trfree_offer_clicked', { source: 'avia' });
